/** @jsx jsx */
import { jsx, Grid, Box } from 'theme-ui'
import { FC } from 'react'
import { CollectionTemplateType } from '~/@types/models'
import ProductItem from '~/components/product-item'
import CollectionLayout from '~/components/layout/collection-layout'
import CollectionProducts from '~/containers/collection-products'
import { space } from '~/gatsby-plugin-theme-ui'
import isolateFilters from '~/utils/filtering'

type Props = CollectionTemplateType

const CollectionRugs: FC<Props> = ({ pageContext: { data } }) => {
  const filterData = isolateFilters(data)
  return (
    <CollectionLayout
      title={data.title}
      description={data.description}
      image={data.image && data.image.originalSrc}
      ankleContent={data.metafields?.ankleContent}
    >
      <CollectionProducts
        collectionHandle={data.handle}
        initialData={data.products}
        pagination={data.pagination}
        filters={filterData}
      >
        {props => (
          <Grid columns={[1, 2]} gap={20} className="product-list-rugs-stacked">
            {props.products.map(item => {
              return (
                <Box key={item.id} mb={space.l1}>
                  <ProductItem
                    product={{
                      ...item,
                      mainImage: item.mainImage || item.mainImageLifestyle,
                    }}
                    visibleVariantsCount={9}
                    productImageRatio={1}
                    imageDimensions={{
                      width: [735, 735],
                      height: [735, 735],
                    }}
                  />
                </Box>
              )
            })}
          </Grid>
        )}
      </CollectionProducts>
    </CollectionLayout>
  )
}

export default CollectionRugs
